export function initSplits() {
  document.querySelectorAll('[data-split]').forEach((el) => {
    const text = el.textContent || '';
    el.textContent = '';
    [...text].forEach((ch, i) => {
      const span = document.createElement('span');
      span.className = 'char';
      span.style.transitionDelay = `${i * 36}ms`;
      span.textContent = ch === ' ' ? ' ' : ch;
      el.appendChild(span);
    });
  });

  document.querySelectorAll('.hero [data-split]').forEach((el) => {
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-in')));
  });
}
